module.exports = __webpack_public_path__ + "static/media/authbg.c20ecbf0.jpg";